import script from "./CampaignInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./CampaignInfoCard.vue?vue&type=style&index=0&id=64d58ac8&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d58ac8"]])

export default __exports__